import React from 'react';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import LoadingIndicator from '../LoadingIndicator';
import TokenService from '../../services/TokenService'
import { useSnackbar } from 'notistack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import cloneDeep from 'lodash/cloneDeep';
import SortableFilterTable from '../SortableFilterTable.jsx';
import CustomerItem from './CustomerItem.jsx';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
}
    from '@mui/material/'

function Customers(props) {
    const [searchValue, setSearchValue] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [customers, setCustomers] = React.useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedRow, setSelectedRow] = React.useState(-1);

    function showLoadingIndicator() {
        return <LoadingIndicator Message={'Loading'} />
    }

    function adminClientSearch() {
        if (searchValue.trim().length != 0) {
            let postData = {
                searchValue: searchValue.trim()
            }

            setIsLoading(true);
            TokenService.post(postData, 'Admin_ClientSearch')

                .then((response) => {
                    setIsLoading(false);
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        setCustomers(jsonData);
                    }
                    else {
                        enqueueSnackbar(response.Message, {
                            variant: 'error',
                        });
                    }

                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                    setIsLoading(false);
                });
        }
        else {
            enqueueSnackbar("Can't be blank", {
                variant: 'error',
            });
        }
    }

    function handleRowClick(e, customer) {
        if (customer.ClientId == selectedRow) {
            // same row clicked again
            setSelectedRow(0);
        }
        else {
            setSelectedRow(customer.ClientId);
        }
    }

    function buildCustomers() {
        if (customers.length === 0) {
         return (<div>No results</div>)
        }

        let tableData = [];

       

        let columns = [
            {
                name: 'First',
                mappedProperty: 'CustomerName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Last',
                mappedProperty: 'CustomerLastname',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Email',
                mappedProperty: 'CustomerEmail',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Open',
                mappedProperty: 'OpenOrdersCount',
                dataType: 'numeric',
                canFilter: true
            },
            {
                name: 'Total',
                mappedProperty: 'CompletedOrdersCount',
                dataType: 'numeric',
                canFilter: true
            }

        ]

        return (<div>
            {customers.map((customer, index) => {
                let dataItem = cloneDeep(customer);
                dataItem.OpenOrdersCount = customer.OpenRequests.length;
                dataItem.CompletedOrdersCount = customer.ClosedRequests.length;
                tableData.push(dataItem);
            })
            }
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>Results: {customers.length}</div>
            <SortableFilterTable data={tableData} columns={columns} expandRow={(data) => handleRowExpanded(data)} uniqueIdentifierProperty={'ClientID'} />
        </div>)
    }


    function handleRowExpanded(customer) {
        return <CustomerItem client={customer} onUpdated={(client) => handleClientUpdated(client)} loggedInUser={props.loggedInUser} />
    }

    function handleClientUpdated(client) {
        let temp = cloneDeep(customers);
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].ClientId == client.ClientId) {
                temp[i] = client;
                break;
            }
        }
        setCustomers(temp);
    }

    return (

        <div style={{ marginBottom: '200px' }}>
            {isLoading ?
                showLoadingIndicator()
                :

                <div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <TextField value={searchValue} label='Anything' onChange={(e) => setSearchValue(e.target.value)} />
                        <Fab onClick={adminClientSearch} sx={{ backgroundColor: 'var(--sipzee-green)' }}><SearchIcon /></Fab>
                    </div>
                    <div>
                        {searchValue.trim().length === 0 ? null
                            :
                            buildCustomers()    
                        }
                    </div>
                </div>

            }
        </div>
    )
}
export default Customers;